import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/purchase-order/{poId}/arrival-schedules`。建立交期排程。 */
export async function createArrivalSchedule(poId, payload) {
  const { data: raw } = await request.post(
    `/srm/purchase-order/${poId}/arrival-schedules`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
